<template>
  <TechLayoutContainer>
    <!-- 左侧机器人列表面板 -->
    <div class="left-section">
      <RobotListPanel
        @select-robot="handleSelectRobot"
        :selectedRobotId="selectedRobotId"
        :isClick="isClick"
      />
    </div>

    <!-- 右侧音频属性面板 -->
    <div class="right-section">
      <div class="audio-properties-panel">
        <!-- 科技感装饰元素 -->
        <div class="tech-corner top-left"></div>
        <div class="tech-corner top-right"></div>
        <div class="tech-corner bottom-left"></div>
        <div class="tech-corner bottom-right"></div>

        <div class="panel-header">
          <div class="title">
            <svg-icon :name="panelIcon" class="title-icon"></svg-icon>
            {{ panelTitle }}
          </div>
          <div class="robot-info" v-if="selectedRobotId">
            <img src="@/assets/images/voice/Robot-icon.png" alt="robot" class="robot-avatar">
            <span class="robot-name">{{ currentRobot.name }}</span>
          </div>
          <div class="header-decoration"></div>
        </div>

        <!-- 动态内容组件 -->
        <component
          :is="dynamicComponent"
          v-if="selectedRobotId"
          :key="componentKey"
          :selectedRobot="currentRobot"
          :selectedRobotId="selectedRobotId"
          :disabledStatus="formDisabled"
        />

        <!-- 未选择机器人时的提示 -->
        <div class="no-robot-selected" v-else>
          <div class="empty-icon">
            <svg-icon name="robot" class="robot-icon"></svg-icon>
          </div>
          <div class="empty-message">{{ emptyMessage }}</div>
          <div class="empty-description">{{ emptyDescription }}</div>
        </div>
      </div>
    </div>
  </TechLayoutContainer>
</template>

<script>
import TechLayoutContainer from '@/components/TechLayoutContainer'
import RobotListPanel from './RobotListPanel.vue'
import AudioPropertiesPanel from '@/view/voice/audioProperties/AudioPropertiesPanel.vue'
import SmartConfig from '@/view/intelligentFunction/config/SmartConfig.vue'

export default {
  name: 'AudioProperties',
  components: {
    TechLayoutContainer,
    RobotListPanel,
    AudioPropertiesPanel,
    SmartConfig,
  },
  data() {
    return {
      selectedRobotId: null,
      currentRobot: {
        id: 0,
        name: '',
        code: '',
        avatar: require('@/assets/images/voice/Robot-icon.png'),
        pursuitFuncEnable:null
      },
      // 面板配置字典
      panelConfig: {
        audio: {
          component: 'AudioPropertiesPanel',
          icon: 'audio',
          titleKey: 'audioPropertiesTitle',
          emptyMessageKey: 'selectRobotToViewAudioProperties',
          emptyDescKey: 'selectRobotFromLeftListToConfigureAudio'
        },
        smartConfig: {
          component: 'SmartConfig',
          icon: 'shield',
          titleKey: 'smartConfigTitle',
          emptyMessageKey: 'selectRobotToViewSmartConfig',
          emptyDescKey: 'selectRobotFromLeftListToConfigureSmartSettings'
        }
      },
      formDisabled:false
    }
  },
  computed: {
    // 从路由获取面板类型，默认为 audio
    panelType() {
      // 优先从 query 参数获取
      if (this.$route.query.type) {
        return this.$route.query.type;
      }
      // 其次从 params 获取
      if (this.$route.params.type) {
        return this.$route.params.type;
      }
      // 根据路由 name 或 path 判断
      const routeName = this.$route.name;
      const routePath = this.$route.path;
      
      // 路由名称映射
      const routeNameMap = {
        'SmartConfig': 'smartConfig',
        'AudioProperties': 'audio',
        // 可以继续添加其他路由映射
      };
      
      // 路径映射
      if (routePath && routePath.includes('SmartConfig')) {
        return 'smartConfig';
      }
      
      // 根据路由名称返回
      if (routeName && routeNameMap[routeName]) {
        return routeNameMap[routeName];
      }
      
      // 默认返回 audio
      return 'audio';
    },
    // 当前面板配置
    currentPanelConfig() {
      return this.panelConfig[this.panelType] || this.panelConfig.audio;
    },
    // 动态组件名称
    dynamicComponent() {
      return this.currentPanelConfig.component;
    },
    // 面板标题
    panelTitle() {
      return this.$translate(this.currentPanelConfig.titleKey);
    },
    // 面板图标
    panelIcon() {
      return this.currentPanelConfig.icon;
    },
    // 空状态提示信息
    emptyMessage() {
      return this.$translate(this.currentPanelConfig.emptyMessageKey);
    },
    // 空状态描述
    emptyDescription() {
      return this.$translate(this.currentPanelConfig.emptyDescKey);
    },
    //可点击
    isClick(){
      return ['SmartConfig'].includes(this.currentPanelConfig.component)
    },
    // 组件key，用于强制重新渲染
    componentKey() {
      // 使用路由路径 + 面板类型 + 机器人id 组成唯一key
      return `${this.$route.path}-${this.panelType}-${this.selectedRobotId || 'no-robot'}`;
    }
  },
  watch: {
    // 监听路由变化，重置状态
    '$route': {
      handler(newRoute, oldRoute) {
        // 如果是不同的面板类型或路由，重置状态
        if (oldRoute && (newRoute.name !== oldRoute.name || newRoute.path !== oldRoute.path)) {
          this.resetPageState();
        }
      },
      immediate: false
    },
    // 监听面板类型变化
    panelType(newType, oldType) {
      if (oldType && newType !== oldType) {
        this.resetPageState();
      }
    }
  },
  mounted() {
    // 初始化默认机器人信息的国际化文本
    this.currentRobot.name = this.$translate('pleaseSelectRobot');
    this.currentRobot.code = this.$translate('systemDefault');
  },
  methods: {
    // 处理选中机器人事件
    handleSelectRobot(robot,disabledStatus) {
      this.selectedRobotId = robot.id;
      this.currentRobot = robot;
      this.formDisabled = disabledStatus
    },
    
    // 重置页面状态
    resetPageState() {
      // 重置选中的机器人
      this.selectedRobotId = null;
      
      // 重置机器人信息
      this.currentRobot = {
        id: 0,
        name: this.$translate('pleaseSelectRobot'),
        code: this.$translate('systemDefault'),
        avatar: require('@/assets/images/voice/Robot-icon.png'),
        pursuitFuncEnable:null
      };
      
      // 重置表单禁用状态
      this.formDisabled = false;
      
      console.log('页面状态已重置 - 面板类型:', this.panelType);
    }
  }
}
</script>

<style lang="less" scoped>
.left-section {
  flex: 1;
  min-width: 350px;
  padding: 20px;
  border-right: 1px solid rgba(0, 191, 255, 0.2);
  position: relative;
  z-index: 15;
}

.right-section {
  flex: 2;
  padding: 20px;
  position: relative;
  z-index: 15;
}

.audio-properties-panel {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(10, 25, 50, 0.8);
  border-radius: 15px;
  border: 1px solid rgba(0, 191, 255, 0.3);
  backdrop-filter: blur(10px);
  box-shadow:
    0 0 20px rgba(0, 191, 255, 0.1),
    inset 0 0 10px rgba(0, 191, 255, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 科技感边角 */
.tech-corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid rgba(0, 191, 255, 0.6);
  z-index: 5;
}

.top-left {
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 5px;
}

.top-right {
  top: 0;
  right: 0;
  border-left: none;
  border-bottom: none;
  border-top-right-radius: 5px;
}

.bottom-left {
  bottom: 0;
  left: 0;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 5px;
}

.bottom-right {
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 5px;
}

.panel-header {
  padding: 20px;
  border-bottom: 1px solid rgba(0, 191, 255, 0.2);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #00bfff;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 20px;
  color: #00bfff;
}

.robot-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.robot-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(0, 191, 255, 0.5);
}

.robot-name {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.header-decoration {
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00bfff, transparent);
  animation: glow-line 2s infinite alternate;
}

.no-robot-selected {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
}

.empty-icon {
  margin-bottom: 20px;
}

.robot-icon {
  font-size: 64px;
  color: rgba(0, 191, 255, 0.3);
  animation: float 3s ease-in-out infinite;
}

.empty-message {
  font-size: 20px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 10px;
}

.empty-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
}

/* 动画定义 */
@keyframes glow-line {
  0% {
    opacity: 0.5;
    box-shadow: 0 0 5px rgba(0, 191, 255, 0.3);
  }
  100% {
    opacity: 1;
    box-shadow: 0 0 15px rgba(0, 191, 255, 0.6);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>
